/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TagPostureTagDetails {
    getFixupPrototypeFunction() { return TagPostureTagDetails.fixupPrototype; }

    static newInstance(model: Partial<TagPostureTagDetails>): TagPostureTagDetails {
        let obj = Object.assign(new TagPostureTagDetails(), model);
        TagPostureTagDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TagPostureTagDetails>): TagPostureTagDetails {
        if (!model) return null;
        return TagPostureTagDetails.newInstance(<TagPostureTagDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TagPostureTagDetails) {
        if (!obj) return;

        models.TagPostureTagDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TagPostureTagDetails): boolean {
        Object.setPrototypeOf(obj, TagPostureTagDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Tag key
     */
    tag: string;

    /**
     * Value of tag
     */
    value: string;

    /**
     * Whether the tag is valid
     */
    is_valid: boolean;

    /**
     * Possible values for the key
     */
    auto_suggest: Array<string>;

}
